import { createSelector } from 'reselect';
import { getLabelZoneDataInFormat } from '../utils';

export const getIrisproductCartridgeSlots = (state, selfProps) => ({
    labeledZoneInfo: {
        items: getLabelZoneDataInFormat(
            (selfProps.productGrid && selfProps.productGrid.items) || []
        ),
        header: selfProps.headline || '',
    },
});

const getproductCartridgeSlots = createSelector(
    [getIrisproductCartridgeSlots],
    (irisProductCartridgeSlots) => {
        return irisProductCartridgeSlots;
    }
);

export default getproductCartridgeSlots;
